let mobileMenu = document.querySelector('.burger-container');
let offCanvas = document.querySelector('.off-canvas');
let offCanvasContent = document.querySelector('.off-canvas-content');
let headerContainer = document.querySelector('.header-container');

offCanvas.classList.add('is-closed');
offCanvas.setAttribute('aria-hidden', 'true');

mobileMenu.addEventListener('click', function(){
  if(offCanvas.classList.contains('is-closed')){
    // open
    offCanvas.classList.remove('is-closed');
    offCanvas.classList.add('is-open');
    offCanvas.setAttribute('aria-hidden', 'false');
    offCanvasContent.classList.add('content_pushed-right');
    headerContainer.classList.add('content_pushed-right');
  } else {
    // close
    offCanvas.classList.remove('is-open');
    offCanvas.classList.add('is-closed');
    offCanvas.setAttribute('aria-hidden', 'true');
    offCanvasContent.classList.remove('content_pushed-right');
    headerContainer.classList.remove('content_pushed-right');
  }
}, false);